import React from "react";

const LoadingCard = () => {
  return (
    <div className="w-full rounded-lg">
      {/* Image container */}
      <div className="relative w-full">
        <div className="rounded-md h-48 w-full overflow-hidden relative">
          <div className="w-full h-full bg-gray-200 animate-pulse"></div>
        </div>

        {/* Like button placeholder */}
        <div className="absolute right-3 top-2 w-[27px] h-[27px] rounded-full bg-gray-200 animate-pulse"></div>
      </div>

      {/* Content below image */}
      <div className="flex w-full flex-row items-center justify-between pt-0.5 pb-3">
        <div className="flex flex-col items-start justify-start space-y-2 w-full">
          {/* Title */}
          <div className="w-full pt-1">
            <div className="h-5 bg-gray-200 rounded w-3/4 animate-pulse"></div>
          </div>

          {/* Review score and buttons */}
          <div className="w-full flex flex-row items-center justify-start space-x-2 pr-1">
            <div className="flex flex-row items-center space-x-1.5 w-full pt-1">
              <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
            </div>
            {/* Action buttons */}
            <div className="w-6 h-6 shrink-0 rounded-full bg-gray-200 animate-pulse"></div>
            <div className="w-6 h-6 shrink-0 rounded-full bg-gray-200 animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingCard;
